import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const assetMastersAdapter = createEntityAdapter({})

const initialState = assetMastersAdapter.getInitialState()

export const assetMasterApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAssetMasters: builder.query({
            query: () => ({
                url: '/assetmaster',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedAssetMasters = responseData.map(assetmaster => {
                    // console.log(assetmaster)
                    assetmaster.id = assetmaster._id
                    // console.log(assetmaster)
                    return assetmaster
                });
                return assetMastersAdapter.setAll(initialState, loadedAssetMasters)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'Assetmaster', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Assetmaster', id }))
                    ]
                } else return [{ type: 'Assetmaster', id: 'LIST' }]
            }
        }),
        addNewAssetMaster: builder.mutation({
            query: initialUserData => ({
                url: '/assetmaster',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'Assetmaster', id: "LIST" }
            ]
        }),
        updateAssetMaster: builder.mutation({
            query: initialUserData => ({
                url: '/assetmaster',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Assetmaster', id: arg.id }
            ]
        }),
        addAssetInCat: builder.mutation({
            query: initialUserData => ({
                url: '/assetmaster/addasset',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Assetmaster', id: arg.id }
            ]
        }),
        editAssetOfCat: builder.mutation({
            query: initialUserData => ({
                url: '/assetmaster/editasset',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Assetmaster', id: arg.id }
            ]
        }),
        deleteAssetMaster: builder.mutation({
            query: ({ id }) => ({
                url: `/assetmaster`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Assetmaster', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetAssetMastersQuery,
    useAddNewAssetMasterMutation,
    useUpdateAssetMasterMutation,
    useDeleteAssetMasterMutation,
    useAddAssetInCatMutation,
    useEditAssetOfCatMutation
} = assetMasterApiSlice

// returns the query result object
export const selectAssetMastersResult = assetMasterApiSlice.endpoints.getAssetMasters.select()

// creates memoized selector
const selectAssetMastersData = createSelector(
    selectAssetMastersResult,
    assetMastersResult => assetMastersResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllAssetMasters,
    selectById: selectAssetMasterById,
    selectIds: selectAssetMasterIds
    // Pass in a selector that returns the users slice of state
} = assetMastersAdapter.getSelectors(state => selectAssetMastersData(state) ?? initialState)